<template>
  <v-col cols="12" md="6" class="mb-2">
    <AppSelect
      v-if="metadataOptions"
      :model-value="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
      :items="metadataOptions"
      :label="metadataLabel"
      :disabled="disabled"
      item-title="label"
      item-value="key"
      data-locator="metadata-select"
    >
    </AppSelect>
  </v-col>
</template>

<script lang="ts">

import AppSelect from '@/common/AppSelect.vue'

export default {
  name: 'ProjectsMetadataSelect',
  components: { AppSelect },
  props: {
    modelValue: {
      type: String,
    },
    metadataLabel: {
      type: String,
      default: '',
    },
    metadataOptions: {
      type: Array as () => { key: string; label: string }[],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
}
</script>
